import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { publicAxios } from '../api';

const initialState = {
  facilitesServices: [],
  statusfacilitesServices: 'idle',
  errorfacilitesServices: null,
};

export const fetchFacilitesServices = createAsyncThunk('facilitesServices/fetchFacilitesServices', async () => {
  const response = await publicAxios.get('/api/user/facilites/services');
  return response.data.data.facilities_services;
});

const facilitesServicesSlice = createSlice({
  name: 'facilitesServices',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFacilitesServices.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchFacilitesServices.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.facilitesServices = action.payload;
      })
      .addCase(fetchFacilitesServices.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default facilitesServicesSlice.reducer;